import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate.js"; // Import your configured axios instance
import "./UsersList.css"; // Import the CSS file
import { formatDate } from "../../utils/Utilities.js";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";


const ListOutScanByDate = () => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate("/outscan");
  }
  const [ListOutScanByDate, setListOutScanByDate] = useState([]); // To store list of ListOutScanByDate
  const [loading, setLoading] = useState(false); // Set loading initially to false
  const [error, setError] = useState(null); // To handle errors
  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const [fromDate, setFromDate] = useState(""); // To store the from_date value
  const [toDate, setToDate] = useState(""); // To store the to_date value
  const ListOutScanByDatePerPage = 10; // Number of ListOutScanByDate per page
  const axiosPrivate = useAxiosPrivate();
  const LIST_OUT_SCAN_URL = "api/list-outscan"; // Replace with the correct API endpoint to fetch ListOutScanByDate
  const { auth } = useAuth();


  // Fetch ListOutScanByDate based on from_date and to_date
  const fetchListOutScanByDate = async (fromDate, toDate) => {
    setLoading(true); // Start loading spinner
    try {
      const fromDate_Formated = formatDate(fromDate);
      const toDate_Formated = formatDate(toDate);
      const data = {
        franchise_id: auth.franchise_id,
        from_date: fromDate_Formated,
        to_date: toDate_Formated,
      };

      const response = await axiosPrivate.get(LIST_OUT_SCAN_URL, {
        params: data,
      });

      setListOutScanByDate(response.data); // Store the list of ListOutScanByDate into the state
      setLoading(false); // Stop loading spinner
      setError(null); // Clear any previous error
    } catch (error) {
      console.error("Error fetching Bookings Consignments:", error);
      setError("Failed to load Booking Consignments");
      setLoading(false); // Set loading to false even if there is an error
    }
  };

  // Handle the search button click to fetch data with the new dates
  const handleSearch = () => {
    if (fromDate && toDate) {
      fetchListOutScanByDate(fromDate, toDate);
      setError(null); // Clear the error if dates are valid
    } else {
      setError("Please enter both from and to dates."); // Show error if dates are missing
    }
  };

  // Paginate ListOutScanByDate
  const indexOfLastListOutScanByDate = currentPage * ListOutScanByDatePerPage;
  const indexOfFirstListOutScanByDate = indexOfLastListOutScanByDate - ListOutScanByDatePerPage;
  const currentListOutScanByDate = ListOutScanByDate.slice(indexOfFirstListOutScanByDate, indexOfLastListOutScanByDate);

  // Pagination handler
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Total pages needed for pagination
  const totalPages = Math.ceil(ListOutScanByDate.length / ListOutScanByDatePerPage);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <>


      <section className="newsections">
        <br />

        <div className="newwrap">


          <span className="d-flex justify-content-end gap-2">
            {/* <button onClick={() => window.location.reload()} type="button" className="btn btn-success d-block top-bt">
    Create New
  </button> */}
            <button onClick={handleRedirect} type="button" className="btn btn-success d-block top-bt">
              OutScan
            </button>
          </span>
          <h3>Out Scan List</h3>

          {/* Date Filters and Search Button */}
          <center><div className="search-filters newfilter">
            <label htmlFor="fromDate">From Date:</label>
            <input
              type="date"
              id="fromDate"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
            <label htmlFor="toDate">To Date:</label>
            <input
              type="date"
              id="toDate"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
            <br />
            <button onClick={handleSearch} className="btn scanbutton">Search</button>
          </div>
          </center>

          {/* Show error message if both dates are not provided */}
          {error && (
            <div className="error-message">
              <div className="error">{error}</div>
              {/* Show the search filters again below the error */}
            </div>
          )}

          {/* Show the table for displaying ListOutScanByDate only when there are results */}
          {ListOutScanByDate.length > 0 && !error && (
            <>
              <table border="1" id="customers">
                <thead>
                  <tr>
                    <th>AWB Number</th>
                    <th>Consignment Type</th>
                    <th>Goods Name</th>
                    <th>Quantity</th>
                    <th>Weight</th>
                    <th>Scan Time</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {currentListOutScanByDate.map((ListOutScanByDate) => (
                    <tr key={ListOutScanByDate.awb_number}>
                      <td>{ListOutScanByDate.awb_number}</td>
                      <td>{ListOutScanByDate.consignment_type}</td>
                      <td>{ListOutScanByDate.goods_name}</td>
                      <td>{ListOutScanByDate.quantity}</td>
                      <td>{ListOutScanByDate.weight}</td>
                      <td>{ListOutScanByDate.scan_time}</td>
                      <td>{ListOutScanByDate.status}</td>

                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination - only show if there are multiple pages */}
              {totalPages > 1 && (
                <div className="pagination">
                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      disabled={currentPage === index + 1}>
                      {index + 1}
                    </button>
                  ))}
                </div>
              )}
            </>
          )}

          {/* If no ListOutScanByDate and error isn't shown, display a "No results" message */}
          {ListOutScanByDate.length === 0 && !loading && !error && (
            <div className="no-results">
              <p>No Booking Consignments found for the selected date range.</p>
            </div>
          )}
        </div>
      </section>
      <TopBar />
    </>
  );
};

export default ListOutScanByDate;
